import { EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VisitorCardService } from './../../../services/visitor-card.service';
import { Component, OnInit, Input } from '@angular/core';
import { VisitorCardStub } from 'src/app/data/VisitorCardStub';

@Component({
  selector: 'app-visitor-card-search-results',
  templateUrl: './visitor-card-search-results.component.html',
  styleUrls: ['./visitor-card-search-results.component.css']
})
export class VisitorCardSearchResultsComponent implements OnInit {
  @Input() visitorCardStubs: VisitorCardStub[];
  @Output() visitorCardStubSelected: EventEmitter<
    VisitorCardStub
  > = new EventEmitter();

  constructor(
    private visitorCardService: VisitorCardService,
    private router: Router
  ) {}

  ngOnInit() {}

  selectVisitorCardStub(visitorCardStub: VisitorCardStub) {
    this.visitorCardService.selectVisitorCardStub(visitorCardStub);
    this.router.navigate(['/visitorCards/accounts']);
    this.visitorCardStubSelected.emit(visitorCardStub);
  }

  storeRecentVisitorCardStub(visitorCardStub: VisitorCardStub): void {
    this.visitorCardService.storeRecentVisitorCardStub(visitorCardStub);
  }
}
